<template>
  <!-- 数据折叠组件 -->
  <div class="tabcon1" @click="closefix()" @touchmove.prevent>
    <div class="conbox">
      <div class="condet1" :style="{ top: $utils.px2rem(cTop || top + 'px') }">
        <cube-scroll class="inner-div">
          <div class="list_" :class="{ flexlist: type == 'long' }">
            <span
              :class="[
                colNum == 4 ? 'list4' : 'list3',
                index === nowIndex ? 'on' : '',
                type == 'long' ? 'long' : ''
              ]"
              v-for="(item, index) in dataList"
              :key="item.id"
              @click.stop="selectClick(index, item.name, item.code)"
              >{{ item.name }}</span
            >
          </div>
        </cube-scroll>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 一排放几个
    colNum: {
      default: 4
    },
    dataList: {
      // 数据列表
      type: Array
    },
    // 距离顶部距离
    top: {
      type: String,
      default: '90px'
    },
    // 现在激活的数据
    nowIndex: {
      type: Number
    },
    // 是否flex布局
    type: {
      type: String
    }
  },
  data() {
    return {
      cTop: ''
    }
  },
  methods: {
    // 点击数据
    selectClick(index, name, code) {
      this.$emit('selectClick', index, name, code)
    },
    // 关闭数据
    closefix() {
      this.$emit('closeBg')
    }
  }
}
</script>
<style scoped lang="scss">
.tabcon1 {
  width: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 5;
  &.conindex {
    z-index: 8;
  }
  .conbox {
    position: relative;
    height: 100%;
    .condet1 {
      position: absolute;
      overflow: hidden;
      overflow-y: scroll;
      top: 99px;
      left: 0;
      right: 0;
      bottom: 0;
      font-size: 14px;
      color: #333;
      background: rgba(0, 0, 0, 0.3);
      max-height: calc(100vh - 90px);
      .inner-div {
        overflow: hidden;
        min-height: 0px;
      }
      .list_ {
        background-color: #fff;
        padding: 10px 6.67% 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        &.flexlist {
          justify-content: space-between;
          flex-wrap: nowrap;
        }
        span {
          font-size: 12px;
          color: #666;
          height: 35px;
          line-height: 35px;
          display: inline-block;
          background-color: #f5f5f5;
          border-radius: 5px;
          text-align: center;
          width: 73px;
          margin-bottom: 15px;
          margin-right: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          padding: 0 5px;
          // 一排4个
          box-sizing: border-box;
          &.list4 {
            &:nth-child(4n),
            &:last-child {
              margin-right: 0;
            }
          }
          // 一排三个
          &.list3 {
            width: 98px;
            &:nth-child(3n),
            &:last-child {
              margin-right: 0;
            }
            &:nth-child(4n) {
              margin-right: 10px;
            }
          }
          &.on {
            background-color: #c7a283;
            color: #fff;
          }
          &.long {
            width: 155px;
          }
        }
      }
    }
  }
}
</style>
